import { Stack } from 'expo-router';

export default function AdminSegmentLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="index" />
      <Stack.Screen name="check-in" />
      <Stack.Screen name="moderation" />
      <Stack.Screen name="events" />
      <Stack.Screen name="[tenant]" />
    </Stack>
  );
}
